import React, {useState} from "react";
import {LocalizationInfo} from "react-i18next";
import {HeroBody, HeroParagraph, LocalizedTextLabel} from "../text";
import {ArrowDownIcon} from "../icons";
import {useTranslation} from "next-i18next";

export interface FaqItem {
  question: string | LocalizationInfo
  answer: string | LocalizationInfo
  id: string
}

export interface LandingFaqSectionViewProps {
  items: FaqItem[]
}

export const LandingFaqSectionView: React.FC<LandingFaqSectionViewProps> = ({ items }) => {
  const { t } = useTranslation()
  const [itemState, setItemState] = useState<{ [key: string]: boolean }>({})

  return <div className="max-w-screen-lg">
    {items.map((item, index) => {
      const isEven = index % 2 === 0
      const isOpen = itemState[item.id] ?? false

      return <div
        key={item.id}
        className={`w-full flex flex-col cursor-pointer overflow-y-hidden ${isOpen ? 'space-y-3' : 'space-y-0'} px-6 lg:px-8 py-4 lg:py-6 rounded-xl ${isEven ? 'bg-fg-gray-surface' : ''}`}
        onClick={() => {
          setItemState({ ...itemState, [item.id]: !isOpen })
        }}
      >
        <div className={`w-full flex space-x-4 items-center`}>
          <HeroBody className="flex-grow"><LocalizedTextLabel t={t} text={item.question} /></HeroBody>
          <ArrowDownIcon className={`h-4 w-4 lg:h-5 lg:w-5 flex-shrink-0 transform transition-all ${isOpen ? 'rotate-180' : 'rotate-0'}`} />
        </div>

        <div className={`${isOpen ? '' : 'max-h-0'} transition-all overflow-hidden`}>
          <HeroParagraph className="text-fg-gray-dark"><LocalizedTextLabel t={t} text={item.answer} /></HeroParagraph>
        </div>
      </div>
    })}
  </div>
}